export default "__VITE_ASSET__DmJCcBAA__"